'use strict';

var angular = require('angular');
var dependencies = ['AVRO.Common.Configuration'];
module.exports = angular.module('AVRO.DemandTransparency.SaveExclusions', dependencies).controller('SaveExclusionsPopupController', require('./controllers/SaveExclusionsPopupController')).directive('rmSaveExclusionsPopup', require('./directives/SaveExclusionsPopupDirective'));